import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../Components/SEO/SEO.jsx";
import { ArrowLeft, Apple, Smartphone } from "lucide-react";
import "./Install.css";

const Install = () => {
  return (
    <div className="Install fade-in">
      <SEO
        title="Установить приложение — Шахризада"
        description="Как добавить сайт кафе Шахризада на главный экран iPhone или Android."
      />

      <Link to="/" className="Install--Back">
        <ArrowLeft size={18} /> На главную
      </Link>

      <header className="Install--Head">
        <h1 className="Install--Title">Приложение на телефоне</h1>
        <p className="Install--Lead muted">
          Сайт можно установить как приложение: ярлык на экране, быстрый доступ
          к меню и заказу без поиска вкладки в браузере.
        </p>
      </header>

      <section className="Install--Block">
        <h2 className="Install--BlockTitle">
          <Apple size={22} aria-hidden />
          iPhone и iPad (Safari)
        </h2>
        <ol className="Install--Steps">
          <li>Откройте сайт в браузере Safari.</li>
          <li>
            Нажмите кнопку «Поделиться»{" "}
            <span className="Install--Hint">(квадрат со стрелкой вверх)</span>.
          </li>
          <li>
            Прокрутите меню и выберите{" "}
            <strong>«На экран Домой»</strong> / «Add to Home Screen».
          </li>
          <li>При необходимости измените название и нажмите «Добавить».</li>
        </ol>
        <p className="Install--Note muted">
          На iOS установка доступна только из Safari, не из Chrome или других
          браузеров.
        </p>
      </section>

      <section className="Install--Block">
        <h2 className="Install--BlockTitle">
          <Smartphone size={22} aria-hidden />
          Android (Chrome)
        </h2>
        <ol className="Install--Steps">
          <li>Откройте сайт в Google Chrome.</li>
          <li>
            Нажмите меню{" "}
            <span className="Install--Hint">три точки вверху справа</span>.
          </li>
          <li>
            Выберите <strong>«Установить приложение»</strong> или «Добавить на
            главный экран».
          </li>
          <li>Подтвердите установку.</li>
        </ol>
        <p className="Install--Note muted">
          На некоторых телефонах пункт может называться «Установить» или
          появиться баннер «Установить приложение» внизу экрана — нажмите его.
        </p>
      </section>

      <p className="Install--Footer muted">
        После установки иконка появится рядом с другими приложениями. Чтобы
        удалить ярлык, как обычное приложение: долгое нажатие → удалить.
      </p>
    </div>
  );
};

export default Install;
